const ICONS = {
  bebida_alcoholica: '🍺',
  bebida_no_alcoholica: '🥤',
  snack: '🍿',
  tabaqueria: '🚬',
  farmacia: '💊',
  otro: '📦',
};

export function emojiProducto(p) {
  return ICONS[p?.categoria] ?? ICONS.otro;
}

export function ProductoFoto({ producto, size = 'md', className = '' }) {
  const sz = size === 'lg' ? 'h-32' : size === 'sm' ? 'h-16' : 'h-24';
  if (producto.foto_url) {
    return (
      <div className={`${sz} w-full rounded-2xl overflow-hidden bg-bone relative ${className}`}>
        <div className="absolute inset-0 flex items-center justify-center text-4xl opacity-30 pointer-events-none">{emojiProducto(producto)}</div>
        <img
          src={producto.foto_url}
          alt={producto.nombre}
          className="relative w-full h-full object-cover"
          loading="lazy"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>
    );
  }
  return (
    <div className={`${sz} w-full rounded-2xl bg-bone flex items-center justify-center ${className}`}>
      <span className="text-5xl">{emojiProducto(producto)}</span>
    </div>
  );
}

export function ProductoCard({ producto, cantidad = 0, onAdd, onSub }) {
  const fmt = (n) => '$ ' + new Intl.NumberFormat('es-CO').format(n ?? 0);
  return (
    <div className={`relative rounded-3xl border bg-paper p-3 transition-all duration-200 ${cantidad > 0 ? 'border-ink shadow-[0_12px_24px_-12px_rgba(27,42,78,0.4)] -translate-y-0.5' : 'border-line hover:border-ink/40'}`}>
      <ProductoFoto producto={producto} />
      <div className="mt-3 px-1">
        <div className="font-semibold tracking-tight text-sm leading-tight line-clamp-2 min-h-[2.6em]">{producto.nombre}</div>
        <div className="font-mono text-[11px] mt-1 text-ink">{producto.precio_venta > 0 ? fmt(producto.precio_venta) : <span className="text-muted">Sin precio</span>}</div>
      </div>
      <div className="mt-3 flex items-center justify-between gap-2">
        {cantidad > 0 ? (
          <>
            <button
              type="button"
              onClick={onSub}
              className="w-9 h-9 rounded-full bg-bone hover:bg-line text-ink font-bold text-lg leading-none transition active:scale-95"
            >−</button>
            <div className="font-mono text-lg font-bold text-ink">{cantidad}</div>
            <button
              type="button"
              onClick={onAdd}
              disabled={producto.precio_venta <= 0}
              className="w-9 h-9 rounded-full bg-ink hover:bg-ink-soft text-paper font-bold text-lg leading-none transition active:scale-95 disabled:opacity-40"
            >+</button>
          </>
        ) : (
          <button
            type="button"
            onClick={onAdd}
            disabled={producto.precio_venta <= 0}
            className="w-full py-2 rounded-2xl bg-bone hover:bg-ink hover:text-paper transition font-semibold text-sm tracking-tight disabled:opacity-40 disabled:hover:bg-bone disabled:hover:text-ink"
          >+ Agregar</button>
        )}
      </div>
    </div>
  );
}
